import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TipSelectorValue, TipType } from '../../components/tip-selector/tip-selector.component';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';

@Component({
	selector: 'app-absolute-tip-input-modal',
	standalone: false,
	templateUrl: './absolute-tip-input-modal.component.html',
	styleUrls: ['./absolute-tip-input-modal.component.scss'],
})
export class AbsoluteTipInputModalComponent {
	selectedTip: TipSelectorValue = {
		value: 0,
		type: TipType.ABSOLUTE,
		icon: '',
	};
	private modalCtrl: ModalController = inject(ModalController);
	private repositoryService = inject(RepositoryService);
	text: string = this.repositoryService.currencyFormat.format(0);

	constructor() {}

	get value(): number {
		return this.selectedTip.value;
	}

	set value(value: number) {
		this.text = this.repositoryService.currencyFormat.format(value / 100);
		this.selectedTip.value = value;
	}

	static async show(modalCtrl: ModalController): Promise<TipSelectorValue> {
		const modal = await modalCtrl.create({
			component: AbsoluteTipInputModalComponent,
		});
		await modal.present();
		const { data } = await modal.onDidDismiss();
		return data;
	}

	confirm() {
		this.modalCtrl.dismiss({
			type: TipType.ABSOLUTE,
			value: this.selectedTip.value / 100,
		});
	}

	close() {
		this.modalCtrl.dismiss();
	}

	onInput(event: any) {
		const rawValue = event.target.value || '';
		const digits = rawValue.replace(/\D/g, '');
		const newIntValue = parseInt(digits, 10) || 0;

		const format = this.repositoryService.currencyFormat.formatToParts(0);
		const currencySymbol = format.find(part => part.type === 'currency')?.value || '';

		// This is a workaround for a glitch on some mobile keyboards where backspace
		// removes the currency symbol but doesn't reduce the number of digits.
		const isBackspaceGlitch = !rawValue.includes(currencySymbol) && newIntValue === this.value;

		if (isBackspaceGlitch) {
			this.value = Math.trunc(this.value / 10);
		} else {
			this.value = newIntValue;
		}
	}
}
